<template>
  <span class="ProfileIcon">
    <i class="fa" :class="icon"></i>
  </span>
</template>

<script>
export default {
  name: 'ProfileIcon',
  props: ['icon'],
}
</script>

<style lang="scss" scoped>
.ProfileIcon {
  height: 1.8em;
  width: 1.8em;
  min-width: 1.8em; // Needed in a flex wrapper
  display: inline-grid;
  place-items: center;
  border: 2px solid;
  border-radius: 50%;

  i {
    font-size: .9em;
  }
}
</style>
